import React, { useState } from "react";
import logo from "../../Assets/Logo/small.png";
import user from "../../Assets/Icon/user.webp";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { VerifyOTP, VerifyOTPSend } from "../../Repository/Api";
import { registerDetails } from "../../Store/auth/action";
import { errorMsg, successMsg } from "../Toastify";

const ForgetPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [login, SetLogin] = useState([]);
  const [validation, setValidation] = useState({});

  const setData = (e, key) => {
    let TempData = login;
    TempData[key] = e;
    SetLogin(TempData);
    if (validation[key]) setValidation({ ...validation, [key]: false });
  };
  const CheckValidation = () => {
    let Status = true,
      validdateData = {};
    if (!login.user_name) {
      validdateData.user_name = "User Id or Email ID is Required";
      Status = false;
    }

    setValidation({ ...validation, ...validdateData });
    return Status;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const Payload = {
      user_name: login.user_name,
      otp_type: "forgot_password",
    };
    if (CheckValidation()) {
      const response = await VerifyOTPSend(Payload);
      if (response && response.statusCode === 200) {
        dispatch(registerDetails(login.user_name));
        successMsg(response.message);
        getTimeout();
      } else {
        errorMsg(response.message);
      }
    }
  };
  const getTimeout = () => {
    setTimeout(() => {
      setTimeout(navigate("/VerifyOTP"));
    }, 1000);
  };

  return (
    <>
      <section className="signin">
        <div className="container">
          <div className="row">
            <div className="col-lg-5 ms-auto mx-auto">
              <div className="signinlogospace">
                <div className="centertext">
                  <img className="signinlogo" src={logo} alt="NITTTR" />
                </div>
                <div className="mt-5">
                  <h4 className="fw-bold textcolor">Forgot Password?</h4>
                  <p className="fw-bold textcolor">
                    <small>Welcome back Please Enter your Email</small>
                  </p>
                </div>

                <div className="my-5">
                  <form onSubmit={(e) => handleSubmit(e)}>
                    <div className="inputspace">
                      <img className="icon" src={user} alt="User" />
                      <input
                        type="text"
                        className="input-field"
                        placeholder="ENTER EMPLOYEE ID / EMAIL ID"
                        defaultValue={login.user_name}
                        onChange={(e) => {
                          setData(e.target.value, "user_name");
                        }}
                      />
                      {validation.user_name && (
                        <p className="validationmsg">{validation.user_name}</p>
                      )}
                    </div>
                    <div className="inputspace">
                      <button className="loginbtn">Get OTP</button>
                    </div>
                    <div className="d-flex justify-content-end">
                      <p
                        className=" cursor"
                        onClick={() => {
                          navigate("/Login");
                        }}
                      >
                        <small>Back To Login</small>
                      </p>
                    </div>
                    
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ForgetPassword;
